// extracted by mini-css-extract-plugin
export default {"f":"_9a6d351aa6","main":"_9b69e13d50","btn":"d7c264e61f","w":"b7e4506dde","h":"_5ad7bd004f","lh25":"_264f6dcb3d","wb":"_7e4a5cb81a","b":"_8d31a96313","bx":"_43a8762e7e"};